'use es6';

import { Component } from 'react';
import { cleanSelectionRects } from 'rich-text-lib/utils/selection';
import { compose } from 'rich-text-lib/utils/iterables';
import { jsx as _jsx } from "react/jsx-runtime";
const rangeRectToEl = ({
  top,
  left,
  height,
  width
}, offsetTop, offsetLeft) => {
  const selection = document.createElement('div');
  selection.style.position = 'absolute';
  selection.style.zIndex = 10;
  selection.style.userSelect = 'none';
  selection.style.top = 0;
  selection.style.left = 0;
  selection.style.transform = `translate3d(${left - offsetLeft}px, ${top - offsetTop}px, 0)`;
  selection.style.height = `${height}px`;
  selection.style.width = `${width}px`;
  selection.style.backgroundColor = 'rgba(0, 0, 0, 0.17)';
  selection.dataset.mceBogus = true;
  return selection;
};
export default function withFakeSelection(WrappedComponent) {
  return class WithFakeSelection extends Component {
    constructor() {
      super();
      this.handleSelectionChange = this.handleSelectionChange.bind(this);
      this.handleNodeChange = this.handleNodeChange.bind(this);
      this.drawSelection = this.drawSelection.bind(this);
      this.cleanSelection = this.cleanSelection.bind(this);
      this.setFocus = this.setFocus.bind(this);
      this.handleBlur = this.handleBlur.bind(this);
      this.selectionContainer = null;
      this.isFocused = null;
    }
    componentDidMount() {
      const {
        editor
      } = this.props;
      editor.getDoc().addEventListener('selectionchange', this.handleSelectionChange);
      editor.on('NodeChange', this.handleNodeChange);
      editor.on('SetContent', this.cleanSelection);
      editor.on('focus', this.setFocus);
      editor.on('blur', this.handleBlur);
    }
    componentWillUnmount() {
      const {
        editor
      } = this.props;
      if (editor.destroyed) {
        return;
      }
      this.cleanSelection();
      editor.getDoc().removeEventListener('selectionchange', this.handleSelectionChange);
      editor.off('NodeChange', this.handleNodeChange);
      editor.off('SetContent', this.cleanSelection);
      editor.off('focus', this.setFocus);
      editor.off('blur', this.handleBlur);
    }
    setFocus() {
      this.isFocused = true;
    }
    handleBlur() {
      this.isFocused = false;
      this.cleanSelection();
    }
    getFakeSelectionId() {
      return `editor-${this.props.editor.id}-fake-selection`;
    }
    hasDrawnSelection() {
      return this.selectionContainer && this.selectionContainer.nodeType === Node.ELEMENT_NODE;
    }
    getOldSelection() {
      return this.props.editor.dom.get(this.getFakeSelectionId());
    }
    handleNodeChange() {
      if (this.hasDrawnSelection()) {
        this.handleSelectionChange();
      }
    }
    handleSelectionChange() {
      const {
        editor
      } = this.props;
      if (editor.destroyed) {
        return;
      }
      const editorSelection = editor.selection;
      const windowSelection = editor.getWin().getSelection();
      if (this.hasDrawnSelection()) {
        this.cleanSelection();
      }
      if (!editorSelection.isCollapsed() && windowSelection.isCollapsed) {
        const range = editorSelection.getRng();
        const rangeRects = compose(cleanSelectionRects, Array.from)(range.getClientRects());
        this.drawSelection(rangeRects);
      }
    }
    drawSelection(rangeRects) {
      if (!Array.isArray(rangeRects)) {
        console.warn(`rangeRects must be an array, got ${typeof rangeRects} instead`);
        return;
      }
      if (!this.isFocused) return;
      const {
        editor
      } = this.props;
      const selectionRoot = editor.getBody();
      const selectionRootRect = selectionRoot.getBoundingClientRect();
      const offsetLeft = selectionRootRect.left;
      const offsetTop = selectionRootRect.top;
      this.selectionContainer = document.createElement('div');
      this.selectionContainer.id = this.getFakeSelectionId();
      this.selectionContainer.dataset.mceBogus = true;
      rangeRects.forEach(rect => {
        const rangeEl = rangeRectToEl(rect, offsetTop, offsetLeft);
        this.selectionContainer.appendChild(rangeEl);
      });
      selectionRoot.appendChild(this.selectionContainer);
    }
    cleanSelection() {
      const oldSelection = this.getOldSelection();
      if (this.hasDrawnSelection()) {
        this.props.editor.dom.remove(this.selectionContainer);
        this.selectionContainer = null;
      } else if (oldSelection) {
        this.props.editor.dom.remove(oldSelection);
      }
    }
    render() {
      return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, this.props));
    }
  };
}